import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import AppWrapper from '../../../components/AppWrapper';
import Button from '../../../components/Button';
import ErrorMessage from '../../../components/ErrorMessage';
import { LinkComponent } from '../../../components/Link';
import { TextH3, TextP } from '../../../components/Text';
import { useVolunteer } from '../../../hooks';
import * as Styled from '../../../styles/EditDeleteStyles';
import { fonts } from '../../../styles/theme';

const VolunteerDelete = () => {
  const location: any = useLocation();
  const params = useParams();

  const {
    nameSingle,
    name,
    baseUrl,
    volunteers,
    selectVolunteers,
    setSelectVolunteers,
    handleDelete,
    getVolunteersById,
    getBreadcrumbs,
    errors,
  } = useVolunteer();

  useEffect(() => {
    if (location.state?.ids) {
      setSelectVolunteers(location.state.ids);
      getVolunteersById(location.state.ids);
    }
  }, [location]);

  useEffect(() => {
    if (params.id) {
      setSelectVolunteers([parseInt(params.id, 10)]);
      getVolunteersById([parseInt(params.id, 10)]);
    }
  }, [params]);

  return (
    <AppWrapper breadcrumbs={getBreadcrumbs()}>
      <Styled.TextWrapper>
        <TextH3 font={fonts.font1.H20}>Are you sure?</TextH3>
      </Styled.TextWrapper>
      {Object.keys(errors).length > 0 && (
        <ErrorMessage message={errors.message} />
      )}
      {volunteers.length === 1 ? (
        <TextP font={fonts.font1.H14}>
          Are you sure you want to delete the {nameSingle} “{volunteers[0].first_name} {volunteers[0].last_name}({volunteers[0].email})”? All of the following related items will be deleted:
        </TextP>
      ) : (
        <TextP font={fonts.font1.H14}>
          Are you sure you want to delete the selected {name}? All of the following objects and their related items will be deleted:
        </TextP>
      )}
      <div>
        <Styled.TextWrapper>
          <TextP font={fonts.font1.H16B}>Summary</TextP>
          <Styled.ListStyled>
            <li>
              {name}: {volunteers.length}
            </li>
          </Styled.ListStyled>
        </Styled.TextWrapper>
      </div>
      <div>
        <TextP font={fonts.font1.H16B}>Objects</TextP>
        {volunteers && (
          <Styled.ListStyled>
            {volunteers?.map((authority: { name?: string, id?: number }) => (
              <li key={authority.id}>
                {nameSingle}: {authority.id}
                <LinkComponent url={`/${baseUrl}}/${authority.id}`}>
                  {authority.name}
                </LinkComponent>
              </li>
            ))}
          </Styled.ListStyled>
        )}
        <Styled.FlexBoxStyled>
          <Button
            onClick={() => handleDelete(selectVolunteers)}
            theme="warning"
          >
            <TextP font={fonts.font1.H12}>Yes, I&apos;m sure</TextP>
          </Button>
          <Styled.ButtonWrapper>
            <LinkComponent
              url={volunteers.length === 1 ? `/${baseUrl}/${volunteers[0].id}/change` : `/${baseUrl}`}
              theme="buttonSecondary"
            >
              <div>
                <TextP font={fonts.font1.H12}>
                  No, take me back
                </TextP>
              </div>
            </LinkComponent>
          </Styled.ButtonWrapper>
        </Styled.FlexBoxStyled>
      </div>
    </AppWrapper>
  );
};

export default VolunteerDelete;
